import React from "react";

import * as S from "./styles";

export const Hermes: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="first">
        <S.Wrapper>
          <S.Text>
            <p>
              Pegando carona nessa tendência, a francesa Hermès também lançou um
              produto. O tecido, que leva o nome de Sylvania , nasceu em
              parceria com a startup de biotecnologia{" "}
              <a
                href="https://www.mycoworks.com/"
                target="_blank"
                rel="noreferrer"
              >
                MycoWorks
              </a>
              . A colaboração resultou em uma releitura da icônica bolsa de
              viagem Victoria e levou três anos para ser desenvolvida.
            </p>
            <S.Photo1Wrapper>
              <S.Photo1 />
              <S.CreditPhoto1>Hermes Micélio</S.CreditPhoto1>
            </S.Photo1Wrapper>
          </S.Text>
          <S.Text>
            <p>
              Mas não é somente o cogumelo que fornece uma alternativa para o
              couro. A{" "}
              <a
                href="https://desserto.com.mx/"
                target="_blank"
                rel="noreferrer"
              >
                Desserto
              </a>{" "}
              é uma empresa mexicana que trabalha com cactos cultivados
              organicamente. Um metro do couro vegano é produzido com apenas
              duas folhas de cacto e, após dois anos de pesquisa, o esforço foi
              reconhecido comercialmente pela H&M na coleção{" "}
              <a
                href="https://www2.hm.com/en_us/life/culture/inside-h-m/science-story.html"
                target="_blank"
                rel="noreferrer"
              >
                Science Story
              </a>
              . A Gucci é outro exemplo recente. Entrando na corrida, ela
              revelou agora em junho que desenvolveu dentro de casa o Demetra,
              que já está sendo utilizado em alguns modelos de tênis. Ele é 77%
              plant-based e possui milho e trigo não geneticamente modificados
              na composição.
            </p>

            <p>
              O{" "}
              <a
                href="https://www.ananas-anam.com/"
                target="_blank"
                rel="noreferrer"
              >
                Piñatex
              </a>
              , couro de abacaxis, também é uma inovação que já foi abraçada
              comercialmente. A{" "}
              <a
                href="https://www.hugoboss.com/mx/men-vegan-shoes/"
                target="_blank"
                rel="noreferrer"
              >
                Hugo Boss lançou tênis
              </a>{" "}
              feitos com o material e a brasileira{" "}
              <a
                href="https://insectashoes.com/blogs/blog/conheca-a-historia-do-pinatex-nosso-novo-material-%F0%9F%8D%8D"
                target="_blank"
                rel="noreferrer"
              >
                Insecta Shoes
              </a>{" "}
              também já explorou o Piñatex em seus produtos.
            </p>

            <p>
              As opções para o couro ficaram populares, mas não é apenas para
              esse material que existem novas possibilidades biotecnológicas.
              Para imaginar diferentes futuros sustentáveis, designers parecem
              entrar em uma competição de quanto mais inédito o material,
              melhor. Algas marinhas, teias de aranha e até fluidos corporais
              são os novos caminhos pelos quais podemos imaginar o futuro das
              roupas e dos acessórios.
            </p>
          </S.Text>
        </S.Wrapper>
      </S.Content>
      <S.Photo2Wrapper>
        <S.CreditPhoto2>Desserto</S.CreditPhoto2>
        <S.Photo2 />
      </S.Photo2Wrapper>
      <S.Photo3Wrapper>
        <S.CreditPhoto3>H&M</S.CreditPhoto3>
        <S.Photo3 />
      </S.Photo3Wrapper>
    </S.Container>
  );
};
